// extracted by mini-css-extract-plugin
export default {"container":"ClientGuidelines-module__container--39cb"};